export default __webpack_public_path__ + "static/media/product-06 (1).d0cdaded.jpg";